import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import { connect, useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { toast } from 'react-toastify';
import ReCAPTCHA from 'react-google-recaptcha';
import 'react-toastify/dist/ReactToastify.css';
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup
} from 'reactstrap';
import { signIn } from '../../store/action/index';
import {
  getLogoURL,
  getLogoSocialURL
} from '../../views/SystemParams/services/getLogoURL';
import './Login.css';
import { buttonStyle } from 'components/Containers/ConfigurationContainer/components/utils';
import ReactLoader from 'components/Loader';
import { apiAuth } from '../../http';

import googleIcon from '../../assets/img/icons/common/google.svg';
import microsoftIcon from '../../assets/img/icons/common/microsoft-logo.svg';
import { useVerifyRolesContext } from 'hooks/useVerifyRoles';
import { checkBlocked } from 'store/action/auth';
import { getKeyRecaptcha } from 'store/action/auth';

const Login = (props) => {
  const [dataLogin, SetDataLogin] = useState({
    login: {
      elementType: 'input',
      type: 'text',
      placeholder: 'Login de acesso',
      name: 'login',
      value: '',
      validation: {
        required: true
      },
      valid: false,
      touched: 'false'
    },
    password: {
      elementType: 'input',
      type: 'password',
      placeholder: 'Senha',
      name: 'password',
      value: '',
      validation: {
        required: true
      },
      valid: false,
      touched: 'false'
    }
  });
  const { roles } = useVerifyRolesContext();
  const [logoURL, setLogoURL] = useState();
  const [logoSocialURL, setLogoSocialURL] = useState();
  const [googleCode, setGoogleCode] = useState('');
  const [microsoftCode, setMicrosoftCode] = useState(null);
  const [loading, setLoading] = useState(false);
  const [tokenRecaptcha, setTokenRecaptcha] = useState(null);
  const [showMessageRecaptcha, setShowMessageRecaptcha] = useState(false);
  const [blocked, setBlocked] = useState(false);
  const [clientRecaptchaKey, setClientRecaptchaKey] = useState(null);

  const systemConfiguration = useSelector((state) => state.systemConfiguration);

  const handleThirdPartyAuthSuccess = (response) => {
    const { data } = response;
    localStorage.setItem(
      'should_sign_in_asterisk',
      data.should_sign_in_asterisk
    );
    localStorage.setItem('queuesToSignId', JSON.stringify(data.queuesToSignId));
    localStorage.setItem('use_scale', data.use_scale);
    localStorage.setItem('is_using_scale', !!data.scale_id);
    localStorage.setItem('agent_code', data.agent_code);
    localStorage.setItem('token', data.token);
    localStorage.setItem('name', data.name);
    localStorage.setItem('queues', JSON.stringify(data.queues));
    localStorage.setItem('extensions', JSON.stringify(data.extensions));
    localStorage.setItem('teams', JSON.stringify(data.teams));
    localStorage.setItem('login', data.login);
    localStorage.setItem('nickname', data.nickname);
    localStorage.setItem('type_of_pause', data.type_of_pause);
    localStorage.setItem('is_paused', data.is_paused);
    localStorage.setItem('isLoginExtension', false);
    localStorage.setItem('webrtc_auto_login', data.webrtc_auto_login);
    localStorage.setItem('show_all_conversations', data.show_all_conversations);
    localStorage.setItem('show_all_protocols', data.show_all_protocols);
    localStorage.setItem('show_all_leads', data.show_all_leads);
    localStorage.setItem('show_all_opportunities', data.show_all_opportunities);
    localStorage.setItem('pin_code', data.pin_code);
    window.dispatchEvent(new Event('rolesShouldReload'));
    window.location.reload();
  };

  useEffect(() => {
    if (googleCode.length > 10) {
      const decodedUri = decodeURIComponent(googleCode);
      const baseUrl = window.location.origin;
      apiAuth
        .post('/oauth/google', {
          code: decodedUri,
          redirectUri: `${baseUrl}/`
        })
        .then((res) => handleThirdPartyAuthSuccess(res))
        .catch(() => {
          toast.error('E-mail não cadastrado no FlexUC');
        });
    }
  }, [googleCode]);

  useEffect(() => {
    if (microsoftCode) {
      setLoading(true);
      const decodedUri = decodeURIComponent(microsoftCode);
      apiAuth
        .post('/oauth/microsoft', {
          code: decodedUri
        })
        .then((res) => handleThirdPartyAuthSuccess(res))
        .catch(() => {
          toast.error('E-mail não cadastrado no FlexUC');
          setLoading(false);
        });
    }
  }, [microsoftCode]);

  useEffect(() => {
    checkBlocked(setBlocked);
    const url = window.location.href;
    const codeMatch = url.match(/[?&]code=([^&]+)/);
    if (codeMatch) {
      const code = codeMatch[1];
      setMicrosoftCode(code);
    }
  }, []);

  useEffect(() => {
    //   getDefaultTheme();

    getKeyRecaptcha().then((data) => {
      setClientRecaptchaKey(data);
    });

    getLogoURL()
      .then((source) => {
        setLogoURL(source);
      })
      .catch(() => console.error('[LOGIN FORM] Error loading logo'));

    getLogoSocialURL()
      .then((source) => {
        setLogoSocialURL(source);
      })
      .catch(() => console.error('[LOGIN FORM] Error loading social logo'));
  }, []);

  const checkValidity = (value, rules) => {
    let isValid = true;
    if (!rules) {
      return true;
    }

    if (rules.required) {
      isValid = value.trim() !== '' && isValid;
    }

    if (rules.minLength) {
      isValid = value.length >= rules.minLength && isValid;
    }

    if (rules.maxLength) {
      isValid = value.length <= rules.maxLength && isValid;
    }

    if (rules.isNumeric) {
      const pattern = /^\d+$/;
      isValid = pattern.test(value) && isValid;
    }

    return isValid;
  };

  const inputChangedHandler = (event, controlName) => {
    const updatedState = {
      ...dataLogin,
      [controlName]: {
        ...dataLogin[controlName],
        value: event.target.value,
        valid: checkValidity(
          event.target.value,
          dataLogin[controlName].validation
        ),
        touched: 'true'
      }
    };
    SetDataLogin(updatedState);
  };

  const submitAuth = async (event) => {
    event.preventDefault();
    const login = dataLogin.login.value;
    const password = dataLogin.password.value;
    // await handleRecaptcha();
    if (blocked && !tokenRecaptcha) {
      toast.error('Por favor, confirme o reCAPTCHA');
      setShowMessageRecaptcha(true);
      return;
    }

    props.signIn(login, password, tokenRecaptcha, setBlocked);
  };

  const notifySucessLogin = (nameUser) =>
    toast.info('Seja bem-vindo(a) ' + nameUser, {
      autoClose: 3000,
      closeOnClick: true
    });
  let buttonSingIn = null;
  if (!props.loading) {
    buttonSingIn = (
      <Button
        onClick={submitAuth}
        className="my-4 g4-button"
        type="submit"
        style={buttonStyle(systemConfiguration.primary_color)}
      >
        Entrar
      </Button>
    );
  } else {
    buttonSingIn = (
      <div>
        <ReactLoader />
      </div>
    );
  }
  if (props.should_sign_in_asterisk) return <Redirect to="/LoginAutoAuth" />;

  if (props.token) {
    notifySucessLogin(props.name);
    return <Redirect to="/admin" />;
  }

  if (localStorage.getItem('token')) {
    const roleNames = (roles ?? []).map(({ role }) => role);

    if (
      roleNames.includes('AGENT_DASHBOARD') &&
      !roleNames.includes('DASHBOARD')
    ) {
      return <Redirect from="*" to="/admin/dashboard/agent" />;
    }

    return <Redirect from="*" to="/admin/dashboard" />;
  }

  const getGoogleAuthUrl = async () => {
    const baseUrl = window.location.origin;
    const response = apiAuth
      .get(`/oauth/google/get-auth?redirectUri=${baseUrl}/`)
      .then((res) => {
        return res.data.authorizationUrl;
      })
      .catch((error) => {
        console.log('Erro no auth', error);
        toast.info(
          'Não foi possível conectar ao Google. Tente novamente mais tarde.'
        );
        return undefined;
      });
    return response;
  };

  const handleGoogleAuth = async () => {
    const url = await getGoogleAuthUrl();
    const authPopup = window.open(
      url,
      'Pop up window',
      'popup=true, width=500, height=600, top=100,left=100'
    );

    if (window.focus) {
      authPopup.focus();
    }
    const intervalId = setInterval(() => {
      try {
        if (!authPopup.closed) {
          const popupUrl = authPopup.location.href;
          if (popupUrl && popupUrl.includes('code=')) {
            const urlParams = new URLSearchParams(authPopup.location.search);
            const code = urlParams.get('code');
            if (code) {
              setGoogleCode(code);
              authPopup.close();
            }
          }
        }
      } catch (error) {
        console.error(error);
        // Ignorar erros de cross-origin enquanto o popup ainda estiver na página de login do Google
      }

      if (authPopup?.closed) {
        clearInterval(intervalId);
      }
    }, 1000);
  };

  const getMicrosoftAuthUrl = async () => {
    const baseUrl = window.location.origin;
    const response = apiAuth
      .get(`/oauth/microsoft/get-auth?redirectUri=${baseUrl}/sso/microsoft`)
      .then((res) => {
        return res.data.authorizationUrl;
      })
      .catch((error) => {
        toast.error(
          error.response.data.message ||
            'Não foi possível conectar ao Microsoft. Tente novamente mais tarde.'
        );
        return undefined;
      });
    return response;
  };

  const handleMicrosoftAuth = async () => {
    const url = await getMicrosoftAuthUrl();
    if (!url) {
      return;
    }
    window.location.href = url;
  };

  if (loading) {
    return <ReactLoader />;
  }

  return (
    <div className="login-container fadeIn">
      <div className="logo">
        <img src={logoSocialURL} alt="logo" />
      </div>
      <div className="form-container">
        <div className="img-logo-g4flex">
          <img src={logoURL} style={{ maxWidth: '200px' }} alt="logo_g4" />
        </div>
        <Card className="bg-secondary border-0 mb-0">
          <CardHeader className="bg-transparent pb-2">
            <div className="text-muted text-center mt-2 mb-3">
              <h3>{systemConfiguration.welcome_msg}</h3>
            </div>
          </CardHeader>
          <CardBody className="px-lg-5 py-lg-5">
            <Form onSubmit={submitAuth} role="form">
              <FormGroup
                className={classnames('mb-3', {
                  focused: 'login'
                })}
              >
                <InputGroup className="input-group-merge input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-email-83" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    type={dataLogin.login.type}
                    placeholder={dataLogin.login.placeholder}
                    name={dataLogin.login.name}
                    value={dataLogin.login.value}
                    invalid={!dataLogin.login.valid}
                    touched={dataLogin.login.touched}
                    onChange={(event) =>
                      inputChangedHandler(event, dataLogin.login.name)
                    }
                  />
                </InputGroup>
              </FormGroup>
              <FormGroup
                className={classnames({
                  focused: 'password'
                })}
              >
                <InputGroup className="input-group-merge input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-lock-circle-open" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    type={dataLogin.password.type}
                    placeholder={dataLogin.password.placeholder}
                    name={dataLogin.password.name}
                    value={dataLogin.password.value}
                    invalid={!dataLogin.password.valid}
                    touched={dataLogin.password.touched}
                    onChange={(event) =>
                      inputChangedHandler(event, dataLogin.password.name)
                    }
                  />
                </InputGroup>
              </FormGroup>
              <div className="text-center">{buttonSingIn}</div>
              <br />

              {blocked && clientRecaptchaKey && (
                <div
                  style={{
                    flexDirection: 'column',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  {showMessageRecaptcha && (
                    <div className="recaptcha-message text-red-400 mb-2">
                      Por favor, confirme o reCAPTCHA
                    </div>
                  )}
                  <ReCAPTCHA
                    sitekey={clientRecaptchaKey}
                    type="image"
                    hl="pt-BR"
                    onChange={(e) => {
                      setTokenRecaptcha(e);
                      setShowMessageRecaptcha(false);
                    }}
                    onErrored={(e) => {
                      console.log('Erro no reCAPTCHA', e);
                    }}
                  />
                </div>
              )}
            </Form>
            <hr style={{ margin: '1.5rem 0' }} />

            <div className="text-center text-muted mb-4">
              Entrar com:
              <br />
            </div>
            <div className="login-buttons-container">
              <Button
                name="GoogleSingIn"
                onClick={() => {
                  handleGoogleAuth();
                }}
                className="login-button ml-0 mr-0"
              >
                <span>
                  <img
                    src={googleIcon}
                    alt="Fazer login com a conta Google"
                    className="login-button-icon"
                  />
                </span>
                <span>Google</span>
              </Button>
              <Button
                name="MicrosoftSingIn"
                onClick={() => {
                  handleMicrosoftAuth();
                }}
                className="login-button ml-0 mr-0"
              >
                <span>
                  <img
                    src={microsoftIcon}
                    alt="Fazer login com a conta Microsoft"
                    className="login-button-icon"
                  />
                </span>
                <span>Microsoft</span>
              </Button>
            </div>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    loading: state.auth.loading,
    error: state.auth.error,
    token: state.auth.token,
    name: state.auth.name,
    visible: state.auth.visible,
    should_sign_in_asterisk: state.auth.should_sign_in_asterisk,
    queuesidToSignIn: state.auth.queuesidToSignIn
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    signIn: (login, password, tokenCheck, setBlocked) =>
      dispatch(signIn(login, password, tokenCheck, setBlocked))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
